<div class="auth-block">

  <h1 id="title" class="title">Cambio Password</h1>
  <p class="sub-title">Inserisci una nuova password</p>

  <nb-alert *ngIf="showMessages.error && errors?.length && !submitted" outline="danger" role="alert">
    <p class="alert-title"><b>Errore!</b></p>
    <ul class="alert-message-list">
      <li *ngFor="let error of errors" class="alert-message">{{ error }}</li>
    </ul>
  </nb-alert>

  <nb-alert *ngIf="showMessages.success && messages?.length && !submitted" outline="success" role="alert">
    <p class="alert-title"><b>Successo!</b></p>
    <ul class="alert-message-list">
      <li *ngFor="let message of messages" class="alert-message">{{ message }}</li>
    </ul>
  </nb-alert>

  <form (ngSubmit)="resetPass()" #resetPassForm="ngForm" aria-labelledby="title" id="change-psw-form">

    <!-- PASSWORD PRECEDENTE -->
    <div class="row">
      <div class="form-control-group col">
        <label class="label" for="input-old-password">Vecchia Password:</label>
        <input nbInput
              [(ngModel)]="user.oldPassword"
              #oldPassword="ngModel"
              type="password"
              id="input-old-password"
              name="old-password"
              class="first"
              placeholder="Vecchia Password"
              autofocus
              fullWidth
              autocomplete="current-password"
              fieldSize="medium"
              [status]="oldPassword.dirty ? (oldPassword.invalid  ? 'danger' : 'success') : 'basic'"
              [required]="getConfigValue('forms.validation.password.required')"
              [minlength]="getConfigValue('forms.validation.password.minLength')"
              [maxlength]="getConfigValue('forms.validation.password.maxLength')"
              [attr.aria-invalid]="oldPassword.invalid && oldPassword.touched ? true : null">
        <ng-container *ngIf="oldPassword.invalid && oldPassword.touched">
          <p class="caption status-danger" *ngIf="oldPassword.errors?.['required']">
            Inserisci una password!
          </p>
          <p class="caption status-danger" *ngIf="oldPassword.errors?.['minlength'] || oldPassword.errors?.['maxlength']">
            La password dovrebbe avere
            tra i {{ getConfigValue('forms.validation.password.minLength') }}
            e i {{ getConfigValue('forms.validation.password.maxLength') }}
            caratteri
          </p>
        </ng-container>
      </div>
    </div>

    <!-- NUOVA PASSWORD -->
    <div class="row">
      <div class="form-control-group col">
        <label class="label" for="input-password">Nuova Password:</label>
        <input nbInput
              [(ngModel)]="user.newPassword"
              #newPassword="ngModel"
              type="password"
              id="input-password"
              name="password"
              class="mid"
              placeholder="Nuova Password"
              fullWidth
              fieldSize="medium"
              autocomplete="new-password"
              [status]="newPassword.dirty ? (newPassword.invalid  ? 'danger' : 'success') : 'basic'"
              [required]="getConfigValue('forms.validation.password.required')"
              [minlength]="getConfigValue('forms.validation.password.minLength')"
              [maxlength]="getConfigValue('forms.validation.password.maxLength')"
              [attr.aria-invalid]="newPassword.invalid && newPassword.touched ? true : null">
        <ng-container *ngIf="newPassword.invalid && newPassword.touched">
          <p class="caption status-danger" *ngIf="newPassword.errors?.['required']">
            Inserisci una password!
          </p>
          <p class="caption status-danger" *ngIf="newPassword.errors?.['minlength'] || newPassword.errors?.['maxlength']">
            La password dovrebbe avere
            tra i {{ getConfigValue('forms.validation.password.minLength') }}
            e i {{ getConfigValue('forms.validation.password.maxLength') }}
            caratteri
          </p>
        </ng-container>
      </div>
    </div>

    <!-- CONFERMA NUOVA PASSWORD -->
    <div class="row">
      <div class="form-control-group col">
        <label class="label" for="input-re-password">Conferma Password:</label>
        <input nbInput
          [(ngModel)]="user.confirmPassword"
          #rePass="ngModel"
          id="input-re-password"
          name="rePass"
          type="password"
          class="last"
          placeholder="Conferma Password"
          fullWidth
          fieldSize="medium"
          autocomplete="new-password"
          [status]="rePass.touched
              ? (rePass.invalid || newPassword.value != rePass.value ? 'danger' : 'success')
              : 'basic'"
          [required]="getConfigValue('forms.validation.password.required')"
          [attr.aria-invalid]="(rePass.invalid || newPassword.value != rePass.value) && rePass.touched ? true : null">
        <ng-container *ngIf="rePass.touched">
          <p class="caption status-danger" *ngIf="rePass.invalid && rePass.errors?.['required']">
            Devi confermare la password!
          </p>
          <p class="caption status-danger" *ngIf="newPassword.value != rePass.value && !rePass.errors?.['required']">
            Le password non corrispondono!
          </p>
        </ng-container>
      </div>
    </div>

    <button nbButton
            status="primary"
            fullWidth
            size="large"
            [disabled]="submitted || !resetPassForm.valid || newPassword.value != rePass.value"
            [class.btn-pulse]="submitted">
      Cambia Password
    </button>
  </form>

</div>
